import {dispatcher} from './instance/dispatcher';

let _ready = false;

/**
 * Notify that the app is ready and wait for any loaders to finish.\
 * If the app is already ready, this will resolve immediately.
 * @returns Promise
 *
 * @example
 * ready().then(() => {...});
 */
export const ready = () => {
	return new Promise<void>((resolve) => {
		const done = () => {
			_ready = true;
			resolve();
		};

		// @ts-ignore
		Netx.Loading ? Netx.Loading.appLoaded(done) : done();
	});
};

/**
 * When/if the app is ready fire the callback
 * @param cb Callback function
 * @param context Dispatcher context
 *
 * @example
 * whenReady(() => {...}, 'myContext');
 */
export const whenReady = (cb: () => void, context: any = window) => {
	if (_ready) return cb();
	dispatcher.off('app:loaded', context);
	dispatcher.once('app:loaded', cb, context);
};

export default whenReady;
